import { RichTextInput } from "ra-input-rich-text";
import { SimpleShowLayout, DateField, Show,SimpleShowLayoutTextField, TextField, RichTextField } from "react-admin";
import { TagsView } from "../moment";
import { FileInput } from "../fileinputs/eventFileUpload";
import { MomentName } from "./list";



export function ChildMomentShow(props) {
    return (
        <Show {...props}>
            <SimpleShowLayout>
                <TextField source="momentName" />
                <TextField source="type" />
                <MomentName source="momentName" />
                <DateField source="momentTime" showTime />
                <RichTextField source="description" />
                <TagsView source="tags" />
                <FileInput source="files" title="Uploaded Files" route="childMoment/upload" />
            </SimpleShowLayout>
        </Show>
    );
}








